import React from "react";
import { Linkedin, Instagram, Mail } from "lucide-react";
import logoImg from "../assets/logo.png";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="relative overflow-hidden border-t border-border bg-background"
    >
      <div className="absolute inset-0 grid-lines opacity-50" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <img src={logoImg} alt="DMASKUT Consultancy" className="h-12 w-auto" draggable="false" />
            <p className="mt-5 max-w-md text-sm text-muted-foreground leading-relaxed">
              DMASKUT Consultancy — one team, eight practice areas. Helping founders, families and enterprises since 2021.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground mb-4">Navigate</div>
            <ul className="space-y-2.5 text-sm">
              {[
                ["What we do", "domains"],
                ["About", "about"],
                ["Services", "services"],
                ["Blog", "blog"],
                ["Team", "team"],
                ["Contact", "contact"],
              ].map(([label, id]) => (
                <li key={id}>
                  <button
                    onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })}
                    className="text-foreground/80 hover:text-[#0A82D8] transition-colors"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground mb-4">Connect</div>
            <a
              href="mailto:Dmaskut@gmail.com"
              className="inline-flex items-center gap-2 text-base text-foreground/90 hover:text-[#0A82D8] transition-colors"
            >
              <Mail className="h-4 w-4" />
              Dmaskut@gmail.com
            </a>
            <div className="mt-4 flex items-center gap-2">
              {[
                { Icon: Linkedin, href: "https://linkedin.com", label: "LinkedIn" },
                { Icon: Instagram, href: "https://instagram.com", label: "Instagram" },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  className="h-9 w-9 rounded-full border border-border flex items-center justify-center hover:border-[#00B4F0] hover:text-[#0A82D8] transition-colors"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-border flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-muted-foreground">
          <div>© {year} DMASKUT Consultancy. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <span>Since 2021</span>
            <span>India · Remote-first</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
